<template>
  <div class="m-sidebar-layout" :class="isShowCustomer ? 'app-customer' : ''">
    <div class="m-menu" :class="{ 'collapsed': collapsed }">
      <div class="logo">空间运维</div>
      <a-menu
        :selectedKeys="[$route.path.slice(1)]"
        mode="inline"
        theme="dark"
        :openKeys.sync="openKeys"
        :inlineCollapsed="collapsed"
        @click="handleClick"
      >
        <template
          v-for="(item) in sidebars">
          <a-menu-item
            v-if="$utils.hasPermission(item.name) && !item.children"
            :key="item.key">
            <a-icon :type="item.icon" />
            <span>{{item.title}}</span>
          </a-menu-item>
          <a-sub-menu :key="item.key" v-if="item.children && item.children.length">
            <span slot="title"><a-icon type="mail" /><span>{{item.title}}</span></span>
            <template
              v-for="(sub) in item.children">
               <a-menu-item
               :key="sub.key"
                v-if="sub.name && $utils.hasPermission(sub.name)">
                <a-icon :type="sub.icon" />
                <span>{{sub.title}}</span>
              </a-menu-item>
            </template>
          </a-sub-menu>
        </template>
      </a-menu>
    </div>
    <div class="content">
      <header class="content__header">
        <div class="left" style="display: flex;align-items:center;">
          <a-icon
          :type="collapsed ? 'menu-unfold' : 'menu-fold'"
          style="font-size: 20px; padding: 19px 24px;cursor: pointer;"
          @click="collapsed = !collapsed" />
          <span style="font-size: 20px;font-weight: 600;">{{customer_title || '管理员'}}</span>
        </div>
        <div class="right">
          <img src="https://gw.alipayobjects.com/zos/antfincdn/XAosXuNZyF/BiazfanxmamNRoxxVxka.png" alt="">
          <div class="name">{{username}}</div>
          <div class="logout" @click="handleLogout">退出</div>
        </div>
      </header>
      <div class="content__body">
        <div class="m-page-header">
          <m-breadcumb></m-breadcumb>
        </div>
        <a-card class="page-content">
          <router-view></router-view>
        </a-card>
        <!-- <router-view class="page-content"></router-view> -->
      </div>
    </div>
  </div>
</template>

<script>
import MBreadcumb from './breadcrumb';
/* eslint-disable */
export default {
  data() {
    return {
      collapsed: false,
      nodes: [],
      sidebars: [
        { title: '首页', name: 'home.index', key: '', icon: 'home' },
        { title: '客户', name: 'customer.index', key: 'customer', icon: 'user' },
        { title: '账号管理', key: 'account', icon: '', children: [
            { title: '用户组', name: 'group.index', key: 'group', icon: 'team' },
            { title: '节点', name: 'node.index', key: 'node', icon: 'build' },
            { title: '管理员', name: 'manage.index', key: 'manage', icon: 'gold' },
          ],
        },
        { title: '设备管理', name: 'product', key: 'product', icon: 'setting', children:[
          { title: '楼宇列表', name: 'building.index', key: 'product/building', icon: 'gold' },
          { title: '会议室列表', name: 'meeting.index', key: 'product/metting', icon: 'build' },
          { title: '设备列表', name: 'product.index', key: 'product/index', icon: 'team' },
          { title: '设备扩展属性', name: 'product.extraa', key: 'product/extra', icon: 'team' },
         ],
        },
        { title: '员工管理', name: 'staff.index', key: 'staff', icon: 'team' },
        { title: '设置', name: 'setting.index', key: 'setting', icon: 'setting' },
      ],
      authId: -1,
      openKeys: [],
      isShowCustomer: false,
      customer_title: '',
      username: '',
    };
  },
  created() {
    const nodes = localStorage.getItem('nodes') || [];
    const authId = localStorage.getItem('auth_id');
    this.authId = authId - 0;
    this.nodes = nodes;
    this.customer_title = localStorage.getItem("customer_title");
    this.username = localStorage.getItem('username')
    this.sidebars = this.sidebars.map((item) => {
      if (this.authId === 0) return item;
      if (item.children) {
        item.children = item.children.filter(child => this.nodes.includes(child.name));
      }
      return item;
    })
    // console.log
    this.sidebars = this.sidebars.filter(item => this.authId === 0 || (!item.children ? this.nodes.includes(item.name) : true));
    // console.log(this.openKeys);
  },
  methods: {
    handleClick(item) {
      this.$router.push(`/${item.key}`);
    },
    handleLogout() {
      localStorage.removeItem('token');
      // sessionStorage.removeItem("productParams")
      // sessionStorage.removeItem("pageParams")
      localStorage.clear()
      this.$router.replace('/login');
      this.$message.success('退出登录成功');
    },
  },
  watch: {
    '$route'(to) {
      const openKeys = [];
      const name = to.name;
      this.sidebars.forEach((item) => {
        if (!item.children || !item.children.length) return;
        const subItem = item.children && item.children.find(child => child.name === name);
        if (subItem) this.openKeys.push(item.key);
      });
      // this.customer_id = localStorage.getItem('customer_id');
      const customer_id = localStorage.getItem('customer_id');
      if (customer_id != 0 && to.name === "home.index") this.isShowCustomer = true;
      else this.isShowCustomer = false;
    },
  },
  components: {
    MBreadcumb,
  },
};
</script>

<style lang="scss">
.m-sidebar-layout {
  display: flex;
  width: 100vw;
  .m-menu {
    max-width: 256px;
    min-width: 256px;
    height: 100vh;
    background: #001529;
    position: fixed;
    top: 0;
    left: 0;
    &.collapsed {
      width: 80px;
      max-width: 80px;
      min-width: 80px;
      & + .content {
        margin-left: 80px;
      }
      .logo {
        font-size: 14px;
        padding: 0;
        text-align: center;
      }
    }
    .logo {
      position: relative;
      height: 64px;
      padding-left: 24px;
      overflow: hidden;
      line-height: 64px;
      cursor: pointer;
      transition: all .3s;
      color: #fff;
      font-weight: 600;
      font-size: 20px;
      font-family: Avenir,Helvetica Neue,Arial,Helvetica,sans-serif;
      vertical-align: middle;
    }
  }
  .content {
    flex: 1;
    margin-left: 256px;
    height: 100vh;
    &__header {
      height: 64px;
      padding: 0;
      background: #fff;
      box-shadow: 0 1px 4px rgba(0,21,41,.08);
      display: flex;
      justify-content: space-between;
      position: relative;
      z-index: 1;
      .right {
        padding-right: 20px;
        display: inline-flex;
        align-items: center;
        img {
          width: 30px;
          height: 30px;
          border-radius: 50%;
        }
        .name {
          margin: 0 10px;
        }
        .logout {
          cursor: pointer;
        }
      }
    }
    &__body {
      margin: 24px;
      min-height: calc(100vh - 144px);
      .m-page-header {
        padding: 16px 24px;
        background: #fff;
        margin: -24px;
        position: relative;
        margin-bottom: 0;
      }
      .page-content {
        margin-top: 24px;
        // margin: 24px 0;
        // padding: 24px;
        height: 100%;
        background: #fff;
        border-radius: 5px;
        .ant-card-body {
          height: 100%;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/sidebar-layout.vue